import type { WorkspaceMemberWithUserDto } from '@up2stay/up2promo-api-client';

export type LeadUserNameParts = {
  firstName?: string | null;
  lastName?: string | null;
  email?: string;
};

export function getUserDisplayName(
  user: LeadUserNameParts | undefined,
): string {
  if (!user) return '';
  const name = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
  return name || user.email || '';
}

export function getInitialsFromDisplayName(displayName: string): string {
  const parts = displayName.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) {
    const part = parts[0];
    return part ? part.slice(0, 2).toUpperCase() : '?';
  }
  const first = parts[0];
  const second = parts[1];
  return `${first?.[0] ?? ''}${second?.[0] ?? ''}`.toUpperCase();
}

export function getUserInitials(user: LeadUserNameParts | undefined): string {
  return getInitialsFromDisplayName(getUserDisplayName(user));
}

export function getMemberDisplayName(
  member: WorkspaceMemberWithUserDto,
): string {
  const workspaceUser = member.user;
  if (!workspaceUser) return '';
  const name =
    `${workspaceUser.firstName ?? ''} ${workspaceUser.lastName ?? ''}`.trim();
  return name || workspaceUser.email || '';
}
